export { FairGameSimComponent } from './fair-game-sim.component';
export * from './fair-game-sim.presets';
